export const date_utils = {};


/*
FrFr FRIENDLY FRAMEWORK
frfr-date-utils
Version ID: 1a 2022-12-15r1
by 
// Please describe here if you customized this file
*/


// TODO MOZDA problem je sto je koriscenje stringa za dobijanej datuma discouraged... na MDN. TREBA PROVERITI
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date


/*
https://dev.mysql.com/doc/refman/8.0/en/datetime.html
https://dev.mysql.com/doc/refman/8.0/en/date-and-time-literals.html
The date and time parts can be separated by T rather than a space. For example, '2012-12-31 11:30:45' '2012-12-31T11:30:45' are equivalent. 
*/


const frfrdatetimeobj_example = {
};


// -----TO OBJ

date_utils.date_to_frfrdatetimeobj = (d) => {
  // d must be js Date
  let fobj = {};
  // modern UTC timezone
  fobj.readme = "This is frfr datatime object. All properties use UTC timezone.";
  fobj.YYYY = ("000" + d.getUTCFullYear()).slice(-4);// year string
  fobj.MM = ("0" + (d.getUTCMonth() + 1)).slice(-2); // month
  fobj.DD = ("0" + d.getUTCDate()).slice(-2); // day
  fobj.hh = ("0" + d.getUTCHours()).slice(-2); // hours
  fobj.mm = ("0" + d.getUTCMinutes()).slice(-2); // minutes
  fobj.ss = ("0" + d.getUTCSeconds()).slice(-2); // seconds
  fobj.sss = ("00" + d.getUTCMilliseconds()).slice(-3); // miliseconds
  // LOCAL TIMEZINE
  fobj.local = {};
  fobj.local.readme2 = "same but in curent user timezone.";
  fobj.local._timezone_offset = d.getTimezoneOffset(); // NOVO
  fobj.local.YYYY = ("000" + d.getFullYear()).slice(-4);// year string
  fobj.local.MM = ("0" + (d.getMonth() + 1)).slice(-2); // month
  fobj.local.DD = ("0" + d.getDate()).slice(-2); // day
  fobj.local.hh = ("0" + d.getHours()).slice(-2); // hours
  fobj.local.mm = ("0" + d.getMinutes()).slice(-2); // minutes
  fobj.local.ss = ("0" + d.getSeconds()).slice(-2); // seconds
  fobj.local.sss = ("00" + d.getMilliseconds()).slice(-3); // miliseconds
  return fobj;
};

date_utils.frfrdatetimestring_to_frfrdatetimeobj = (frfrdatetimestring) => {
  const frfrdatetimestring_format = 'YYYY-MM-DDThh:mm:ss';
  const ds = '-'; // date separator
  const dts = 'T'; // date/time separator
  const ts = ':'; // time separator
  const parsed_dt_arr = frfrdatetimestring.split(dts);
  const f_date = parsed_dt_arr[0];
  let parsed = {};
  parsed.YYYY = f_date.split(ds)[0];// year string
  parsed.MM = f_date.split(ds)[1]; // month
  parsed.DD = f_date.split(ds)[2]; // day
  parsed.hh = "00"; // hours
  parsed.mm = "00"; // minutes
  parsed.ss = "00"; // seconds
  parsed.sss = "000"; // miliseconds
  if (parsed_dt_arr.length > 1) {
    const parsed_time_arr = parsed_dt_arr[1].split(ts);
    if (parsed_time_arr.length > 0) {
      parsed.hh = parsed_time_arr[0]; // hours
      if (parsed_time_arr.length > 1) {
        parsed.mm = parsed_time_arr[1]; // minutes
        if (parsed_time_arr.length > 2) {
          parsed.ss = parsed_time_arr[2]; // seconds
          if (parsed_time_arr.length > 3) {
            parsed.sss = parsed_time_arr[3]; // miliseconds
          }
        }
      }
    }
  }
  const j = {};
  j.js_year = Number.parseInt(parsed.YYYY);
  j.js_month = Number.parseInt(parsed.MM) - 1;
  j.js_day = Number.parseInt(parsed.DD);
  j.js_hour = Number.parseInt(parsed.hh);
  j.js_minute = Number.parseInt(parsed.mm);
  j.js_second = Number.parseInt(parsed.ss);
  j.js_milisecond = Number.parseIntt(parsed.sss);
  // now convert to Date UTC
  const d = new Date(Date.UTC(j.js_year, j.js_month, j.js_day, j.js_hour, j.js_minute, j.js_second, j.js_milisecond));
  const frfrdatetimeobj = date_utils.date_to_frfrdatetimeobj(d);
  return frfrdatetimeobj;
};

date_utils.esdatestring_to_frfrdatetimeobj = (esdatestring) => {
  const frfrdatetimeobj = date_utils.frfrdatetimestring_to_frfrdatetimeobj(esdatestring);
  return frfrdatetimeobj;
};


// -----TO DATE STRING

date_utils.now_frfrdatetimestring = () => {
  const d = new Date();
  const frfrdatetimestring = date_utils.date_to_frfrdatetimestring(d);
  return frfrdatetimestring;
};

date_utils.frfrdatetimeobj_to_frfrdatetimestring = (frfrdatetimeobj) => {
  const ds = "-"; // date separator
  const dts = "T"; // date/time separator
  const ts = ":"; // time separator
  // let datestring = d.getFullYear() + ds + ("0" + (d.getMonth() + 1)).slice(-2) + ds + ("0" + d.getDate()).slice(-2);
  const p = frfrdatetimeobj; // parsed date and time
  const frfrdatetimestring = p.YYYY + ds + p.MM + ds + p.DD + dts + p.hh + ts + p.mm;
  return frfrdatetimestring;
};

date_utils.frfrdatetimestring_to_local_formated_string = (frfrdatetimestring) => {
  const ds = "-"; // date separator
  const dts = "T"; // date/time separator
  const ts = ":"; // time separator
  const SPACE = " "; // time separator
  const pfrfrdatetimeobj = date_utils.frfrdatetimestring_to_frfrdatetimeobj(frfrdatetimestring); // parsed date and time
  const p = pfrfrdatetimeobj.local;
  const frfrdatetimestring2 = p.YYYY + ds + p.MM + ds + p.DD + SPACE + p.hh + ts + p.mm + ts + p.ss;
  return frfrdatetimestring2;
};

date_utils.date_to_frfrdatetimestring = function (d) {
  const frfrdatetimeobj = date_utils.date_to_frfrdatetimeobj(d); // parsed date and time
  const frfrdatetimestring = date_utils.frfrdatetimeobj_to_frfrdatetimestring(frfrdatetimeobj);
  return frfrdatetimestring;
};

date_utils.date_to_esdatestring = function (d) {
  // d must be js Date
  // Date to ECMAScript date string
  const ds = "-"; // date separator
  // let datestring = d.getFullYear() + ds + ("0" + (d.getMonth() + 1)).slice(-2) + ds + ("0" + d.getDate()).slice(-2);
  const p = date_utils.date_to_frfrdatetimeobj(d); // parsed date and time
  const esdatestring = p.YYYY + ds + p.MM + ds + p.DD;
  return esdatestring;
};


// -----TO DATE

date_utils.frfrdatetimestring_to_date = (frfrdatetimestring) => {
  const fobj = date_utils.frfrdatetimestring_to_frfrdatetimeobj(frfrdatetimestring);
  const j = {};
  j.js_year = Number.parseInt(fobj.YYYY);
  j.js_month = Number.parseInt(fobj.MM) - 1;
  j.js_day = Number.parseInt(fobj.DD);
  j.js_hour = Number.parseInt(fobj.hh);
  j.js_minute = Number.parseInt(fobj.mm);
  j.js_second = Number.parseInt(fobj.ss);
  j.js_milisecond = Number.parseInt(fobj.sss);
  // now convert to Date UTC
  const d = new Date(Date.UTC(j.js_year, j.js_month, j.js_day, j.js_hour, j.js_minute, j.js_second, j.js_milisecond));
  return d; // javascript date
};

date_utils.esdatestring_to_date = function (esdatestring) {
  // TODO ???
  console.log(esdatestring);
  const date_number = Date.parse(esdatestring); // unix time number or es date string
  // TODO MOZDA problem je sto je koriscenje stringa za dobijanej datuma discouraged... na MDN. TREBA PROVERITI
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/Date
  // TODO WARNING 
  console.log(date_number);
  if (isNaN(date_number)) {
    console.log('NaN Not a Number!');
  } else {
    console.log('...is number ...converting to Date...');
    const date = new Date(date_number);
    console.log(date);
    return date;
  }
};


// -----TESTING
date_utils.test = () => {
  console.log('*** TESTING');
  console.log('now UTC time new Date().toISOString()', new Date().toISOString());
  let d = new Date();
  console.log('test 1 - Date now - new Date():', d);
  console.log('test 2 - Date to frfrdatetimeOBJ');
  let f1 = date_utils.date_to_frfrdatetimeobj(d);
  console.log(f1);
  console.log('test 3 - frfrdatetimeOBJ to frfrdatetimeSTRING');
  let s1 = date_utils.frfrdatetimeobj_to_frfrdatetimestring(f1);
  console.log(s1);
  console.log('test 4 - frfrdatetimeSTRING to Date');
  let d2 = date_utils.frfrdatetimestring_to_date(s1);
  console.log(d2);
  console.log('test 4 - frfrdatetimeSTRING to LOCAL TIMEZONE FORMATED');
  let s2 = date_utils.frfrdatetimestring_to_local_formated_string(s1);
  console.log(s2);
  console.log('test finished.');
};


// -----?????

date_utils.now_to_frfrdatetimeobj = () => {
  // only for testing
  const d = new Date(); // now time
  const fobj = date_utils.date_to_frfrdatetimeobj(d);
  return fobj;
};


date_utils.svasta = function () {
  let d = new Date();
  let options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  };
  let datum_parsirani_1 = {
    year: d.getFullYear(),
    month: d.getMonth(),
    day: d.getDate(),
    z_test: d.toLocaleString('en-US', options)
  };
  console.log(datum_parsirani_1);
};


/*
ISO STANDARD

https://www.w3schools.com/js/js_date_formats.asp

https://en.wikipedia.org/wiki/Date_format_by_country

The ISO 8601 format (2019-06-06) is intended to harmonize these formats and ensure accuracy in all situations. Many countries have adopted it as their sole official date format,

https://en.wikipedia.org/wiki/ISO_8601


https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse

dateString
A string representing a simplification of the ISO 8601 calendar date extended format (other formats may be used, but results are implementation-dependent).

https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse#Date_Time_String_Format

Date Time String FormatSection
The standard string representation of a date time string is a simplification of the ISO 8601 calendar date extended format (see Date Time String Format section in the ECMAScript specification for more details). For example, "2011-10-10" (date-only form), "2011-10-10T14:48:00" (date-time form), or "2011-10-10T14:48:00.000+09:00" (date-time form with milliseconds and time zone) can be passed and will be parsed. When the time zone offset is absent, date-only forms are interpreted as a UTC time and date-time forms are interpreted as local time.



https://tc39.es/ecma262/#sec-date-time-string-format

Draft ECMA-262 / June 4, 2019
ECMAScript® 2020 Language Specification

20.3.1.15Date Time String Format
ECMAScript defines a string interchange format for date-times based upon a simplification of the ISO 8601 calendar date extended format. The format is as follows:  YYYY-MM-DDTHH:mm:ss.sssZ


ODLUKA:
koristicemo naziv ECMASCRIPT DATE STRING i ECMASTRING DATE-TIME STRING
skraceno
ESDATESTRING
esdatestring
esdatetimestring
esdatetimestring

*/



/*

PARSIRANJE I FORMATIZOVANJE...

https://stackoverflow.com/questions/3552461/how-to-format-a-javascript-date

var datestring = ("0" + d.getDate()).slice(-2) + "-" + ("0"+(d.getMonth()+1)).slice(-2) + "-" +
    d.getFullYear() + " " + ("0" + d.getHours()).slice(-2) + ":" + ("0" + d.getMinutes()).slice(-2);

// 16-05-2015 09:50


https://codehandbook.org/javascript-date-format/


https://www.npmjs.com/package/dateformat

// list of locales
https://gist.github.com/jacobbubu/1836273




*/


/*

SVASTA...

          // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleString
          /*
          datum_js.toLocaleString('en-US', options)
          var date = today.toLocaleFormat('%Y-%M-%D'); //

*/

